import {
  createRouter,
  createWebHistory,
  LocationQueryRaw,
  RouteRecordRaw,
  RouterOptions,
} from 'vue-router'
import qs from 'qs'
import { pickBy } from 'lodash-es'
import config from '@/config'

import AccountRegistrationRoutes from '@/modules/account-registration.routes'
import UserRegistrationRoutes from '@/modules/user-registration.routes'
import DashboardRoutes from '@/modules/dashboard.routes'
import MailboxesRoutes from '@/modules/mailboxes.routes'
import ProjectsRoutes from '@/modules/projects.routes'
import CalendarRoutes from '@/modules/calendar.routes'
import PeopleRoutes from '@/modules/people.routes'
import WorkflowsRoutes from '@/modules/workflows.routes'
import DevelopersRoutes from '@/modules/developers.routes'
import TicketPortalRoutes from '@/modules/ticket-portal.routes'

import { beforeEach } from '@/services/router/router.guards'
import * as routerNames from './router.names'
import { useAppStore } from '@/modules/app/app.store'

import ErrorScreen from '@/screens/errors/error-screen.vue'
import DDErrorHandler from '@/plugins/dd-error-handler/dd-error-handler'
import GoogleDriveAuthSuccess from '@/screens/google-drive-auth-success/google-drive-auth-success.vue'

// Build list of routes
export const routes: RouteRecordRaw[] = [
  ...AccountRegistrationRoutes,
  ...UserRegistrationRoutes,
  ...DashboardRoutes,
  ...MailboxesRoutes,
  ...ProjectsRoutes,
  ...CalendarRoutes,
  ...PeopleRoutes,
  ...WorkflowsRoutes,
  ...DevelopersRoutes,
  ...TicketPortalRoutes,
  {
    path: '/',
    component: ErrorScreen,
    beforeEnter: () => {
      window.location.href = config.serverSideAppUrl
      return false
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: routerNames.NOT_FOUND,
    component: ErrorScreen,
    beforeEnter: () => {
      useAppStore().error = 404
    },
  },

  /**
   * Loading state on Google Drive
   */
  {
    path: '/:accountId/googledriveauth',
    name: routerNames.GOOGLE_DRIVE_AUTH,
    component: GoogleDriveAuthSuccess,
    meta: {
      visibleTo: [1, 2, 3],
      private: true,
    },
  },
]

export const routerOptions: RouterOptions = {
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  parseQuery(query: string) {
    return qs.parse(query, { comma: true }) as ReturnType<NonNullable<RouterOptions['parseQuery']>>
  },
  stringifyQuery(query: LocationQueryRaw): string {
    const filteredQuery = pickBy(query, v => v !== null && String(v).length > 0)
    return qs.stringify(filteredQuery, {
      arrayFormat: 'comma',
      // Values are percent-encoded so text such as a search for "#123", "a&b", "c++" or "x, y" survives a reload;
      // the commas between array items stay as they are
      encodeValuesOnly: true,
    })
  },
}

const router = createRouter(routerOptions)

// Management of all routes
router.beforeEach(to => beforeEach(to, new DDErrorHandler(router)))

export default router
